export default {
    initSelectRegular() {
        let select = $('.select2');

        if (select.length > 0) {
            select.select2({
                minimumResultsForSearch: 5,
            });
        }
    },

    initMultiSelectListing(){
        let select = $('.multi-select-listing .select2');

        if($('.multi-select-listing').hasClass('multi-select-priority')){
            $('.multi-select-list').sortable({
                revert: true,
            });

            $( ".multi-select-list li" ).draggable({
                cursor: "move",
                connectToSortable: ".multi-select-list",
                helper: "clone",
                revert: "invalid"
            });
        };

        if (select.length > 0) {
            select.select2({minimumResultsForSearch: 5});

            $('.multi-select-list').append($('.select2-selection__rendered ul'));

            $('.multi-select-listing select').each(function() {
                var select = $(this);
                var multiSelectList = select.closest('.multi-select-listing').find('.multi-select-list');
                multiSelectList.append(select.next('.select2').find('.select2-selection__rendered ul'));
                multiSelectList.html(select.next('.select2').find('.select2-selection__rendered').html());
                select.on('select2:select select2:unselect', function() {
                    multiSelectList.html(select.next('.select2').find('.select2-selection__rendered').html());
                });

            });

            $('.multi-select-listing.multi-select-priority select').on('change', function(){
                $('.multi-select-list').sortable({
                    revert: true,
                });

                $( ".multi-select-list li" ).draggable({
                    cursor: "move",
                    connectToSortable: ".multi-select-list",
                    helper: "clone",
                    revert: "invalid"
                });
            });

            $('body').on('click', '.multi-select-list .select2-selection__choice__remove', function(){
               let unselectItem = $(this).parent().data('select2-id');
               $(this).closest('.multi-select-listing').find('.select2-container .select2-selection__rendered .select2-selection__choice[data-select2-id="'+unselectItem+'"] button').trigger('click');
               console.log($(this).closest('.multi-select-listing').find('.select2-container .select2-selection__rendered .select2-selection__choice[data-select2-id="'+unselectItem+'"] button'));

            });


        }

        if($('.multi-select-listing .select2-selection__rendered').length > 0){
            $('.multi-select-list').append($('.select2-selection__rendered ul'));
        }

    },

    initSelectWithSearch() {
        let select = $('.select2-search');

        if (select.length > 0) {
            select.select2();
        }
    }
}